import Mock from 'mockjs';
Mock.mock('/api/user/login', {
    "status": 0,
    "data": {
        "id|1001-1100": 0,
        "username": "@cname",
        "email": "@email",
        "phone|1-9": 0,
        "role": 0,
        "createTime": 1524545121218,
        "updateTime": 1524545121218
    }
});

Mock.mock("/dev/general-service/v1/service/supplier/detail","post", 
    { code: '00', 
        body: [
            {
                id: 1,
                supplierId: 1,
                appartmentId: '4133110-A01',
                appartmentName: "后组合灯总成（左）",
                unit: '件',
                count: 40,
                arriveDate: 1524545121218,
                preCount: 38,
                preArriveDate: 1524545121218,
                supplierDetailType: 'E0',
                remark:'ET0试制订单为正式订单\nET1试制预测订单仅供贵司备件参考，ET1试制订单订货数量及到货时间以后期正式订单为准',
            },
            {
                id: 2,
                supplierId: 1,
                appartmentId: '4133110-A01',
                appartmentName: "后组合灯总成（右）",
                unit: '件',
                count: 40,
                arriveDate: 1524545121218,
                preCount: 38,
                preArriveDate: 1524545121218,
                supplierDetailType: 'E0',
                remark:'ET0试制订单为正式订单\nET1试制预测订单仅供贵司备件参考，ET1试制订单订货数量及到货时间以后期正式订单为准',
            }
        ]
    }
);

Mock.mock("/dev/general-service/v1/service/supplier/list", "post", ()=>{
    return { code: '00', 
        body: [
            {
                id: 1,
                account: 'dyxl',
                password: 'dyxl',
                supplierCode:"BQQD-CG-KZET0-DQ-0041",
                supplierName:"微卡/小卡项目",
                supportingPartner:'丹阳市新联汽车配件有限公司',
                contactor: '金位',
                purchaseVicePresident: '金位',
                purchaseVicePresidentMobile: '13436292960',
                purchaseVicePresidentMail: 'xxx.xxx.xx@com.cn',
                techRepresentative: '金位',
                techRepresentativeMobile: '13436292960',
                techRepresentativeMail: 'xxx.xxx.xx@com.cn',
                qualityRepresentative: '金位',
                qualityRepresentativeMobile: '13436292960',
                qualityRepresentativeMail: 'xxx.xxx.xx@com.cn',
                supplierTel: '13436292960',
                supplierFax: '13436292960',
                legalRepresentative: 'XXXX',
                bank: '青岛滨海银行',
                bankCode: '13436292960',
                contractorMobile: '13436292960',
                taxCode: '13436292960',
                contractorMail: 'jinwei@baw.com.cn',
                supplyProduct: 'ABS',
                supplyCarStyle: '小卡',
                supplierAddress: '山东省莱西市姜山镇昌庆路北京汽车制造厂',
                recieveContacterName: '杨守军',
                recieveContacterTel: '13478393859',
                supplierType: 1,
                supplierStatus: '已发货',
                createTime : 1524545121218,
                supplierRelation : 1,
                supplierStru : 2,
                transportWay : 2,
                postCode: '13500010001',
                payCycle: 10,
                payWay: 1,

            },
            {
                id: 2,
                account: 'dyxl',
                password: 'dyxl',
                supplierCode:"BQQD-CG-KZET0-DQ-0041",
                supplierName:"微卡/小卡项目",
                supportingPartner:'丹阳市新联汽车配件有限公司',
                contactor: '金位',
                purchaseVicePresident: '金位',
                purchaseVicePresidentMobile: '13436292960',
                purchaseVicePresidentMail: 'xxx.xxx.xx@com.cn',
                techRepresentative: '金位',
                techRepresentativeMobile: '13436292960',
                techRepresentativeMail: 'xxx.xxx.xx@com.cn',
                qualityRepresentative: '金位',
                qualityRepresentativeMobile: '13436292960',
                qualityRepresentativeMail: 'xxx.xxx.xx@com.cn',
                supplierTel: '13436292960',
                supplierFax: '13436292960',
                legalRepresentative: 'XXXX',
                bank: '青岛滨海银行',
                bankCode: '13436292960',
                contractorMobile: '13436292960',
                taxCode: '13436292960',
                contacterMail: 'jinwei@baw.com.cn',
                supplyProduct: '底盘',
                supplyCarStyle: '皮卡',
                supplierAddress: '山东省莱西市姜山镇昌庆路北京汽车制造厂',
                recieveContacterName: '杨守军',
                recieveContacterTel: '13478393859',
                supplierType: 1,
                supplierStatus: '已确认',
                createTime : 1524545121218,
                supplierRelation : 2,
                supplierStru : 2,
                transportWay : 2,
                postCode: '13500010001',
                payCycle: 10,
                payWay: 1,
            } 
        ]
    }
});

Mock.mock("/dev/general-service/v1/service/supplier/delete", "post", ()=>{
    return{ code: '00', 
        body: []
    }
});